import { SdkResource } from './common';

export const summary = SdkResource.from((client) => ({
  getById: (id: string) =>
    client
      .GET('/summary/{id}', {
        params: { path: { id } },
      })
      .then(({ data: response }) => response?.data || null),
  getByReference: (reference: string) =>
    client
      .GET('/summary', {
        params: { query: { filter: JSON.stringify({ reference }) } },
      })
      .then(({ data: response }) => response?.data || []),
}));
